import SelectedParametersList from "./SelectedParametersList";
import ButtonWithIcon from "../../Buttons/ButtonWithIcon";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import React, { useCallback, useState } from "react";
import { SelectionState, TParameterSelection } from "../index";
import { Modal } from "react-bootstrap";
import ParameterSelection from "./ParameterSelection";
import { omit } from "lodash";
import EuCutOutProductHelpers from "../../../utils/EuCutOutProductHelpers";

interface IProps {
  values: SelectionState;
  limit: number;
  onChange: (values: SelectionState) => void;
}

const parameterSelectionToSelectionState = (selection: Array<TParameterSelection>): SelectionState => {
  return selection.reduce((acc, item) => {
    acc[EuCutOutProductHelpers.parameterSelectionKey(item)] = item;

    return acc;
  }, {} as SelectionState);
}

const ParametersSelector = (props: IProps) => {
  const { values, limit, onChange } = props;
  const [showParamSelection, setShowParamSelection] = useState<boolean>(false);
  const selectionCount = Object.keys(values).length;

  const onParameterSelect = useCallback((selected: Array<TParameterSelection>) => {
    const selectedMapping = parameterSelectionToSelectionState(selected);

    onChange({
      ...values,
      ...selectedMapping
    });

    setShowParamSelection(false);
  }, [onChange, values]);

  const onParameterRemove = useCallback((item: TParameterSelection) => {
    onChange(
      omit(values, EuCutOutProductHelpers.parameterSelectionKey(item))
    )
  }, [onChange, values]);

  const onAddParameterClick = useCallback(() => {
    setShowParamSelection(true);
  }, []);

  const onParameterSelectionHide = useCallback(() => {
    setShowParamSelection(false);
  }, []);

  return (
    <div>
      <SelectedParametersList selection={values} onParameterRemove={onParameterRemove} />

      <div className="selected-parameters-actions">
        <ButtonWithIcon icon={faPlusCircle} onClick={onAddParameterClick}>Add parameters</ButtonWithIcon>
        <div className="count-info">
          Selected parameters: <span
          className={classNames('limit', selectionCount > limit && 'exceeded')}>
              {`${selectionCount}/${limit}`}
            </span>
        </div>
      </div>

      <Modal show={showParamSelection} onHide={onParameterSelectionHide} centered size="lg">
        <Modal.Body>
          <ParameterSelection onSelect={onParameterSelect} />
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ParametersSelector;
